export const styles = {
  sectionContainer: {
    alignItems: "start",
    display: "flex",
    justifyContent: "center",
    position: "relative",
    width: "100%",
  },
};
